import { SET_BREADCRUMB_ITEMS } from "./actionTypes"

// 2)this send the action object to redux
export const setBreadcrumbItems = (title, items, patientCount = 0) => ({
  type: SET_BREADCRUMB_ITEMS,
  payload: {
    title: title,
    items: items,
    patientCount: patientCount,
  },
})
